@layer module {
.recurring-payments {
            display: flex;
            flex-direction: column;
    }

.recurring-payments-loading {
            display: flex;
            flex: 1 1 auto;
            align-items: center;
            justify-content: center;
    }
} // layer module
